var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lzExcel"},[_c('gc-spread-sheets',{staticClass:"sample-spreadsheets",staticStyle:{"width":"100%","height":"100%"},on:{"workbookInitialized":_vm.initSpread}},[_c('gc-worksheet')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c9570cd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lzExcel/lzExcel.vue
// module id = null
// module chunks = 